import { render, staticRenderFns } from "./optimiserPanelEditDialog.vue?vue&type=template&id=b22f028e&scoped=true&"
import script from "./optimiserPanelEditDialog.vue?vue&type=script&lang=js&"
export * from "./optimiserPanelEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22f028e",
  null
  
)

export default component.exports